import * as React from 'react';
export var SelectContext = React.createContext(null);
export var SelectProvider = SelectContext.Provider;
export var SelectConsumer = SelectContext.Consumer;
export var SelectVariant;

(function (SelectVariant) {
  SelectVariant["single"] = "single";
  SelectVariant["checkbox"] = "checkbox";
  SelectVariant["typeahead"] = "typeahead";
  SelectVariant["typeaheadMulti"] = "typeaheadmulti";
})(SelectVariant || (SelectVariant = {}));

export var SelectDirection;

(function (SelectDirection) {
  SelectDirection["up"] = "up";
  SelectDirection["down"] = "down";
})(SelectDirection || (SelectDirection = {}));

export var KeyTypes = {
  Tab: 'Tab',
  Space: ' ',
  Escape: 'Escape',
  Enter: 'Enter',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown'
};